import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {GameService} from "../services/game.service";
import {firstValueFrom, skip, take} from "rxjs";


export const providerGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {

  //only show valid provider pages

  const gameService = inject(GameService);
  const router = inject(Router);

  const requestedProvider = route.params['provider'];

  // let providerToNavigate;
  // providerToNavigate = gameService.providers.find(p => p.routerLink === requestedProvider) //uses initial value when we refresh the page
  // if (providerToNavigate){
  //   return true;
  // }
  // router.navigate(['/not-found']);
  // return false;


  const currentProviders = gameService.providers; //the value of _providersBS - initial providers on refreshing the page
  if( currentProviders.find(p=> p.routerLink === requestedProvider)){
    // console.log('prov guard worked: default provider')

    return true
  }
  //otherwise wait for the list retrieved from games
  const providers = await firstValueFrom(
    gameService.providers$.pipe(
      skip(1), // skips the initial/default provider list
      take(1)  // it only waits for the next update, ensures that the firstValurFrom wont wait forever
    )
  );
  // console.log(providers)
  if(providers.find(p=>p.routerLink === requestedProvider)){
    // console.log('prov guard worked: provider from pipe')
    return true
  }

  // console.log('prov guard worked: no provider')
  router.navigate(['/not-found']);
  return false;


};
